import actions from '../../actionTypes';

export default area => {
  return {
    type: actions.EXPANDED_AREA,
    area
  };
};



// WEBPACK FOOTER //
// ./src/reducers/areas/actions/areaExpanded.js